import { useState, FormEvent } from "react";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

const services = ["Balayage / Highlights","Full Color","Color Correction","Root Touch-Up","Gloss & Toner","Precision Cut & Blowout","Men's Cut & Style","Special Occasion Updo","Keratin Smoothing","Olaplex Bond Repair","Scalp Detox","Tape-In Extensions","Hand-Tied Wefts","Bridal Hair Trial","Wedding Day Styling","Bridal Party Package"];
const stylists = ["Any Available Stylist","Isabelle Fontaine","Margot Delacroix","Sofia Ricci","Elena Vasquez"];
const times = ["9:00 AM","9:30 AM","10:00 AM","10:30 AM","11:00 AM","11:30 AM","12:00 PM","12:30 PM","1:00 PM","1:30 PM","2:00 PM","2:30 PM","3:00 PM","3:30 PM","4:00 PM","4:30 PM","5:00 PM","5:30 PM","6:00 PM"];

export default function BookingPage() {
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const data = new FormData(form);
    const body = new URLSearchParams();
    data.forEach((val, key) => body.append(key, val.toString()));
    setLoading(true);
    try {
      await fetch("https://readdy.ai/api/form/d7dr00fsch5bvrijflvg", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: body.toString(),
      });
      setSubmitted(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <section className="relative w-full h-64 overflow-hidden">
        <img src="https://public.readdy.ai/ai/img_res/cc92057b5e046fb171a7fbe5719f2329.jpg" alt="Booking" className="w-full h-full object-cover object-top" />
        <div className="absolute inset-0 bg-black/55 flex flex-col items-center justify-center text-center px-6">
          <span className="text-[#C9A96E] text-xs font-semibold tracking-[0.3em] uppercase mb-3">Reserve Your Chair</span>
          <h1 className="text-white text-4xl md:text-5xl font-bold" style={{ fontFamily: "'Playfair Display', serif" }}>Book Your Appointment</h1>
        </div>
      </section>

      <section className="py-16 px-6">
        <div className="max-w-4xl mx-auto">
          {submitted ? (
            <div className="text-center py-20">
              <div className="w-20 h-20 flex items-center justify-center mx-auto mb-6 rounded-full bg-[#C9A96E]/10">
                <i className="ri-checkbox-circle-line text-4xl text-[#C9A96E]"></i>
              </div>
              <h2 className="text-neutral-900 text-3xl font-bold mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>Request Received!</h2>
              <p className="text-neutral-500 text-sm max-w-md mx-auto leading-relaxed">Thank you! Our team will confirm your appointment via email or phone within 2 hours during business hours. We can't wait to see you.</p>
            </div>
          ) : (
            <>
              <div className="text-center mb-12">
                <p className="text-neutral-500 text-sm max-w-lg mx-auto leading-relaxed">Fill out the form below and our team will confirm your appointment within 2 hours. First-time clients receive <strong className="text-[#C9A96E]">20% off</strong> their first visit.</p>
              </div>
              <form data-readdy-form id="booking-page-form" onSubmit={handleSubmit} className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="flex flex-col gap-2">
                  <label className="text-neutral-500 text-xs tracking-widest uppercase font-semibold">First Name *</label>
                  <input name="first_name" required type="text" placeholder="Jane" className="border border-neutral-200 rounded-sm px-4 py-3 text-sm focus:outline-none focus:border-[#C9A96E] transition-colors" />
                </div>
                <div className="flex flex-col gap-2">
                  <label className="text-neutral-500 text-xs tracking-widest uppercase font-semibold">Last Name *</label>
                  <input name="last_name" required type="text" placeholder="Smith" className="border border-neutral-200 rounded-sm px-4 py-3 text-sm focus:outline-none focus:border-[#C9A96E] transition-colors" />
                </div>
                <div className="flex flex-col gap-2">
                  <label className="text-neutral-500 text-xs tracking-widest uppercase font-semibold">Email *</label>
                  <input name="email" required type="email" placeholder="jane@example.com" className="border border-neutral-200 rounded-sm px-4 py-3 text-sm focus:outline-none focus:border-[#C9A96E] transition-colors" />
                </div>
                <div className="flex flex-col gap-2">
                  <label className="text-neutral-500 text-xs tracking-widest uppercase font-semibold">Phone</label>
                  <input name="phone" type="tel" placeholder="+1 (702) 000-0000" className="border border-neutral-200 rounded-sm px-4 py-3 text-sm focus:outline-none focus:border-[#C9A96E] transition-colors" />
                </div>
                <div className="flex flex-col gap-2">
                  <label className="text-neutral-500 text-xs tracking-widest uppercase font-semibold">Service *</label>
                  <select name="service" required className="border border-neutral-200 rounded-sm px-4 py-3 text-sm focus:outline-none focus:border-[#C9A96E] transition-colors appearance-none cursor-pointer bg-white">
                    <option value="">Select a Service</option>
                    {services.map(s => <option key={s} value={s}>{s}</option>)}
                  </select>
                </div>
                <div className="flex flex-col gap-2">
                  <label className="text-neutral-500 text-xs tracking-widest uppercase font-semibold">Preferred Stylist</label>
                  <select name="stylist" className="border border-neutral-200 rounded-sm px-4 py-3 text-sm focus:outline-none focus:border-[#C9A96E] transition-colors appearance-none cursor-pointer bg-white">
                    {stylists.map(s => <option key={s} value={s}>{s}</option>)}
                  </select>
                </div>
                <div className="flex flex-col gap-2">
                  <label className="text-neutral-500 text-xs tracking-widest uppercase font-semibold">Preferred Date</label>
                  <input name="date" type="date" className="border border-neutral-200 rounded-sm px-4 py-3 text-sm focus:outline-none focus:border-[#C9A96E] transition-colors cursor-pointer" />
                </div>
                <div className="flex flex-col gap-2">
                  <label className="text-neutral-500 text-xs tracking-widest uppercase font-semibold">Preferred Time</label>
                  <select name="time" className="border border-neutral-200 rounded-sm px-4 py-3 text-sm focus:outline-none focus:border-[#C9A96E] transition-colors appearance-none cursor-pointer bg-white">
                    <option value="">Select a Time</option>
                    {times.map(t => <option key={t} value={t}>{t}</option>)}
                  </select>
                </div>
                <div className="flex flex-col gap-2 md:col-span-2">
                  <label className="text-neutral-500 text-xs tracking-widest uppercase font-semibold">Notes / Hair History</label>
                  <textarea name="notes" rows={4} maxLength={500} placeholder="Tell us about your hair goals, current condition, allergies, or anything else we should know before your visit..." className="border border-neutral-200 rounded-sm px-4 py-3 text-sm focus:outline-none focus:border-[#C9A96E] transition-colors resize-none" />
                </div>
                <div className="md:col-span-2 flex justify-center pt-2">
                  <button type="submit" disabled={loading} className="bg-[#C9A96E] text-white text-sm font-semibold tracking-widest uppercase px-20 py-4 rounded-sm hover:bg-[#b8934f] transition-colors cursor-pointer whitespace-nowrap disabled:opacity-60">
                    {loading ? "Sending..." : "Request Appointment"}
                  </button>
                </div>
              </form>
            </>
          )}
        </div>
      </section>
      <Footer />
    </div>
  );
}
